import { Types } from '@core';
import { ViewportTypes } from '@core/enums';
import { REMOTE_VIEW_ID } from 'types';

const remoteRender3D: Types.HangingProtocol.Protocol = {
	id: 'remoteRender3D',
	name: 'RemoteRender3D',
	locked: true,
	icon: '',
	isPreset: true,
	createdDate: '2024-07-16T10:00:00.000Z',
	modifiedDate: '2024-07-16T10:00:00.000Z',
	availableTo: {},
	editableBy: {},
	protocolMatchingRules: [],
	displaySetSelectors: {
		isReconstructableDisplaySet: {
			seriesMatchingRules: [
				{
					weight: 1,
					attribute: 'isReconstructable',
					constraint: {
						equals: {
							value: true,
						},
					},
					required: true,
				},
			],
		},
	},
	toolGroupIds: ['remoteRender3D'],
	stages: [
		{
			id: '1',
			name: '',
			viewportStructure: {
				layoutType: 'grid',
				properties: {
					rows: 1,
					columns: 1,
					layoutOptions: [
						{
							x: 0,
							y: 0,
							width: 1,
							height: 1,
						},
					],
				},
			},
			viewports: [
				{
					viewportOptions: {
						viewportId: REMOTE_VIEW_ID['3D'],
						viewportType: ViewportTypes.REMOTE_RENDER,
						toolGroupId: '3d',
					},
					displaySets: [
						{
							id: 'isReconstructableDisplaySet',
						},
					],
				},
			],
		},
		{
			id: '2',
			name: '',
			viewportStructure: {
				layoutType: 'grid',
				properties: {
					rows: 3,
					columns: 2,
					layoutOptions: [
						{
							x: 0,
							y: 0,
							width: 1 / 2,
							height: 1,
						},
						{
							x: 1 / 2,
							y: 0,
							width: 1 / 2,
							height: 1 / 3,
						},
						{
							x: 1 / 2,
							y: 1 / 3,
							width: 1 / 2,
							height: 1 / 3,
						},
						{
							x: 1 / 2,
							y: 2 / 3,
							width: 1 / 2,
							height: 1 / 3,
						},
					],
				},
			},
			viewports: [
				{
					viewportOptions: {
						viewportId: REMOTE_VIEW_ID['3D'],
						viewportType: ViewportTypes.REMOTE_RENDER,
						toolGroupId: '3d',
					},
					displaySets: [
						{
							id: 'isReconstructableDisplaySet',
						},
					],
				},
				{
					viewportOptions: {
						viewportId: REMOTE_VIEW_ID['AXIAL'],
						viewportType: ViewportTypes.REMOTE_RENDER,
						toolGroupId: '3d',
					},
					displaySets: [
						{
							id: 'isReconstructableDisplaySet',
						},
					],
				},
				{
					viewportOptions: {
						viewportId: REMOTE_VIEW_ID['CORONAL'],
						viewportType: ViewportTypes.REMOTE_RENDER,
						toolGroupId: '3d',
					},
					displaySets: [
						{
							id: 'isReconstructableDisplaySet',
						},
					],
				},
				{
					viewportOptions: {
						viewportId: REMOTE_VIEW_ID['SAGITTAL'],
						viewportType: ViewportTypes.REMOTE_RENDER,
						toolGroupId: '3d',
					},
					displaySets: [
						{
							id: 'isReconstructableDisplaySet',
						},
					],
				},
			],
		},
		{
			id: '3',
			name: '',
			viewportStructure: {
				layoutType: 'grid',
				properties: {
					rows: 2,
					columns: 3,
					layoutOptions: [
						{
							x: 0,
							y: 0,
							width: 1,
							height: 1 / 2,
						},
						{
							x: 0,
							y: 1 / 2,
							width: 1 / 3,
							height: 1 / 2,
						},
						{
							x: 1 / 3,
							y: 1 / 2,
							width: 1 / 3,
							height: 1 / 2,
						},
						{
							x: 2 / 3,
							y: 1 / 2,
							width: 1 / 3,
							height: 1 / 2,
						},
					],
				},
			},
			viewports: [
				{
					viewportOptions: {
						viewportId: REMOTE_VIEW_ID['3D'],
						viewportType: ViewportTypes.REMOTE_RENDER,
						toolGroupId: '3d',
					},
					displaySets: [
						{
							id: 'isReconstructableDisplaySet',
						},
					],
				},
				{
					viewportOptions: {
						viewportId: REMOTE_VIEW_ID['AXIAL'],
						viewportType: ViewportTypes.REMOTE_RENDER,
						toolGroupId: '3d',
					},
					displaySets: [
						{
							id: 'isReconstructableDisplaySet',
						},
					],
				},
				{
					viewportOptions: {
						viewportId: REMOTE_VIEW_ID['CORONAL'],
						viewportType: ViewportTypes.REMOTE_RENDER,
						toolGroupId: '3d',
					},
					displaySets: [
						{
							id: 'isReconstructableDisplaySet',
						},
					],
				},
				{
					viewportOptions: {
						viewportId: REMOTE_VIEW_ID['SAGITTAL'],
						viewportType: ViewportTypes.REMOTE_RENDER,
						toolGroupId: '3d',
					},
					displaySets: [
						{
							id: 'isReconstructableDisplaySet',
						},
					],
				},
			],
		},
		{
			id: '4',
			name: '',
			viewportStructure: {
				layoutType: 'grid',
				properties: {
					rows: 2,
					columns: 2,
					layoutOptions: [
						{
							x: 0,
							y: 0,
							width: 1 / 2,
							height: 1 / 2,
						},
						{
							x: 1 / 2,
							y: 0,
							width: 1 / 2,
							height: 1 / 2,
						},
						{
							x: 0,
							y: 1 / 2,
							width: 1 / 2,
							height: 1 / 2,
						},
						{
							x: 1 / 2,
							y: 1 / 2,
							width: 1 / 2,
							height: 1 / 2,
						},
					],
				},
			},
			viewports: [
				{
					viewportOptions: {
						viewportId: REMOTE_VIEW_ID['3D'],
						viewportType: ViewportTypes.REMOTE_RENDER,
						toolGroupId: '3d',
					},
					displaySets: [
						{
							id: 'isReconstructableDisplaySet',
						},
					],
				},
				{
					viewportOptions: {
						viewportId: REMOTE_VIEW_ID['AXIAL'],
						viewportType: ViewportTypes.REMOTE_RENDER,
						toolGroupId: '3d',
					},
					displaySets: [
						{
							id: 'isReconstructableDisplaySet',
						},
					],
				},
				{
					viewportOptions: {
						viewportId: REMOTE_VIEW_ID['CORONAL'],
						viewportType: ViewportTypes.REMOTE_RENDER,
						toolGroupId: '3d',
					},
					displaySets: [
						{
							id: 'isReconstructableDisplaySet',
						},
					],
				},
				{
					viewportOptions: {
						viewportId: REMOTE_VIEW_ID['SAGITTAL'],
						viewportType: ViewportTypes.REMOTE_RENDER,
						toolGroupId: '3d',
					},
					displaySets: [
						{
							id: 'isReconstructableDisplaySet',
						},
					],
				},
			],
		},
	],
	callbacks: {
		onProtocolExit: [
			{
				commandName: 'clientClearConnection',
			},
		],
		onProtocolEnter: [
			{
				commandName: 'switchButtonSection',
				commandOptions: {
					buttonSectionID: 'remoteRender3D',
				},
				context: 'DEFAULT',
			},
			{
				commandName: 'onEnterMpr3dProtocol',
				commandOptions: {
					remoteRenderMode: true,
				},
				context: 'CORNERSTONE',
			},
			{
				commandName: 'createNewConnection',
			},
		],
	},
};

export default remoteRender3D;
